module.exports = __webpack_public_path__ + "img/op_glide.71909cb0.svg";